// Animated celestial particle layer — used across the sanctuary.
// Visual behavior preserved exactly from the original App.js implementation.
export const FloatingParticles = ({ count = 40 }) => {
  const particles = Array.from({ length: count }, (_, i) => {
    const type = i % 4 === 0 ? 'gold' : i % 4 === 1 ? 'violet' : i % 4 === 2 ? 'white' : 'gold';
    return {
      id: i,
      type,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      size: type === 'gold' ? `${2 + Math.random() * 3}px` : `${1.5 + Math.random() * 2.5}px`,
      duration: `${6 + Math.random() * 10}s`,
      delay: `${Math.random() * 6}s`
    };
  });

  return (
    <div className="particles-container">
      {particles.map((p) => (
        <div
          key={p.id}
          className={`particle particle-${p.type}`}
          style={{
            left: p.left,
            top: p.top,
            width: p.size,
            height: p.size,
            '--duration': p.duration,
            '--delay': p.delay
          }}
        />
      ))}
    </div>
  );
};

export default FloatingParticles;
